export function resolveSlugForAuthLogin({ matchedCustomerData, fetchedCustomerData, customerKey }) {
  if (matchedCustomerData?.slug) return matchedCustomerData.slug;
  if (fetchedCustomerData?.slug) return fetchedCustomerData.slug;
  if (typeof customerKey === "string" && customerKey.trim()) return customerKey.trim().toLowerCase();
  return null;
}
